import { axiosHandler, axiosConfig } from '@/api/common_helpers.js';
import { AUTHENTICATE_URL, IS_UI_ONLY_MODE } from '@/main.js';

export const authenticate = async ({ username, password, deviceInfo, deviceId }) => {
  try {
    const postData = {
      username,
      password,
      deviceInfo,
      deviceId
    };
    if (IS_UI_ONLY_MODE) {
      console.log("UI_ONLY_MODE", "post", AUTHENTICATE_URL, postData)
      return { accepted: "1", loginToken: "UI_ONLY_MODE_TEST_TOKEN", message: '' }
    }
    const response = await axiosHandler(AUTHENTICATE_URL, postData, axiosConfig());
    const { accepted, loginToken, message } = response.data
    // console.log("authenticate", response.data)
    return {
      accepted,
      loginToken,
      message
    }
  } catch (error) {
    console.error('authenticate', error);
    throw new Error(error);
  }
};
